// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605051000/js/" + chunkId + "." + {"44":"9b18e718","225":"44cd80b6","481":"0fca869e","486":"eef09127","770":"65ab82d3"}[chunkId] + ".0.8244370552514182.chunk.js";
};